<template>
    <div>
        <tab name="4">{{userName}}(ID:{{id}})</tab>
        <user-live :userId="id" :userType="3" :userName.sync="userName"></user-live>
    </div>
</template>

<script>
import Tab from './components/tab';
import UserLive from '@/views/user/components/user-live';
export default {
    props:{
        id:{
            type:[Number,String],
            default: ''
        }
    },
    components:{
        Tab,UserLive
    },
    data() {
        return {
            userName:''
        };
    }
}
</script>